angular.module('schoolLinqApp').factory('sideNavService', [
	'$mdSidenav',
	'$mdComponentRegistry',
	function ($mdSidenav, $mdComponentRegistry) {
		var _navState = {
			isNavOpen: true,
			isNavPinned: window.localStorage.getItem('isNavPinned') === 'false' ? false : true,
		};

		function doesNavExist() {
			try {
				var instance = $mdComponentRegistry.get('left');
				if (instance !== null) return true;
				return false;
			} catch (e) {
				return false;
			}
		}

		function toggleNav() {
			var instance = $mdComponentRegistry.get('left');
			if (instance !== null) {
				$mdSidenav('left').toggle();
				_navState.isNavOpen = this.isNavVisible();
			}
		}

		function togglePinned() {
			var instance = $mdComponentRegistry.get('left');
			if (instance !== null) {
				_navState.isNavPinned = !_navState.isNavPinned;
				window.localStorage.setItem('isNavPinned', _navState.isNavPinned);

				if (_navState.isNavPinned === false) {
					_navState.isNavOpen = false;
				}
			}
		}

		function isNavVisible() {
			var instance = $mdComponentRegistry.get('left');
			if (instance !== null) {
				return $mdSidenav('left').isOpen();
			}
			return false;
		}

		function isNavPinned() {
			return _navState.isNavPinned;
		}

		function getNavState() {
			return _navState;
		}

		return {
			doesNavExist: doesNavExist,
			toggleNav: toggleNav,
			togglePinned: togglePinned,
			isNavVisible: isNavVisible,
			isNavPinned: isNavPinned,
			getNavState: getNavState,
		};
	},
]);
